document.addEventListener("DOMContentLoaded", function () {

  const faqItems = document.querySelectorAll(".pruuvo-faq__item");

  faqItems.forEach((item) => {

    const question = item.querySelector(".pruuvo-faq__question");

    question.addEventListener("click", () => {

      const isOpen = item.classList.contains("active");

      // Close all items
      faqItems.forEach((faq) => {
        faq.classList.remove("active");

        const icon = faq.querySelector(".icon");
        if (icon) {
          icon.textContent = "+";
        }
      });

      // Open clicked item
      if (!isOpen) {

        item.classList.add("active");

        const icon = item.querySelector(".icon");
        if (icon) {
          icon.textContent = "−";
        }

      }

    });

  });

  // Open first FAQ by default
  if (faqItems.length) {

    faqItems[0].classList.add("active");

    const firstIcon = faqItems[0].querySelector(".icon");

    if (firstIcon) {
      firstIcon.textContent = "−";
    }

  }

});